import script from "./TemplateApp.vue?vue&type=script&lang=ts&setup=true"
export * from "./TemplateApp.vue?vue&type=script&lang=ts&setup=true"

import "./TemplateApp.scss?vue&type=style&index=0&id=09186940&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09186940"]])

export default __exports__